import { api } from "bodycodi/cmap/app/js/api";

export const partnerList = async () => {
  try {
    const { data } = await api.get(`/partner/branches`);
    return data;
  } catch (error) {
    throw "";
  }
};
